import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { StorageService } from './storage.service';
import { env } from '../../../env/env';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {
  private baseUrl: string = env.url;
  constructor(
    private http: HttpClient,
    private storageService: StorageService,
    private _Router: Router
  ) { }

  public logout() {
    this.storageService.removeToken();
    this._Router.navigate(['auth/login']);
  }

}
